import { Component } from '@angular/core';
import { CpCompareSidebarService } from '@pages/control-page/control-page-main/control-page-compare/cp-compare-sidebar/cp-compare-sidebar.service';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-cp-compare-graph-legend',
  templateUrl: './cp-compare-graph-legend.component.html',
  styleUrls: ['./cp-compare-graph-legend.component.scss']
})
export class CpCompareGraphLegendComponent {

  private measureCards$ = this.compareSidebarService.measureCards$;

  viewModel$ = combineLatest({
    measureCards: this.measureCards$,
  });

  constructor(
    private compareSidebarService: CpCompareSidebarService,
  ) {}

}
